// src/router/colaboradores.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional', 'acesso_colaboradores', 'supervisor_operacional']


const usuariosColaboradoresBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Colaboradores',
        to: 'Colaboradores'
    }
]

export default [
    {
        path: '/usuarios/colaboradores',
        name: 'Colaboradores',
        component: () => import('@/views/Usuarios/Colaboradores/UsuarioListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Colaboradores',
            breadcrumb: usuariosColaboradoresBreadCrumb
        },
    },
    {
        path: '/usuarios/colaboradores/novo',
        name: 'ColaboradorNovo',
        component: () => import('@/views/Usuarios/Colaboradores/NovoUsuarioPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Colaborador',
            breadcrumb: [
                ...usuariosColaboradoresBreadCrumb,
                {
                    label: 'Colaborador Usuário',
                    to: 'ColaboradorNovo'
                }
            ]
        }
    },
    {
        path: '/usuarios/colaboradores/:id/edit',
        name: 'ColaboradorEdit',
        component: () => import('@/views/Usuarios/Colaboradores/NovoUsuarioPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Colaborador',
            breadcrumb: [
                ...usuariosColaboradoresBreadCrumb,
                {
                    label: 'Novo Colaborador',
                    to: 'ColaboradorNovo'
                }
            ]
        }
    }
];
